import { BaseRequest } from '@/network/requests/BaseRequest'
import { real_batch_info } from '@/interfaces/real_batch_info'
import { $in, like } from '@/network/util/QueryBuilder'

export const realBatchInfoRequest = BaseRequest.build<real_batch_info>('real_batch_info')

/**
 * 根据RollId批量查询。
 * @param ids
 */
export function queryAllByRollIds(ids: string[]) {
	return realBatchInfoRequest.queryAll({ roll_id: { $in: ids } })
}
